<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>
          Cargo:
          <span style="color: red">Receive To Store</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/cargo/delivery">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12" xs="12" md="3">
            <span v-if="record.ocrd">
              Supplier: {{record.ocrd.Name}}
              <br />
              Order number: {{record.DocNum}}
              <br />
            </span>

            <span v-if="record.cargo" style="color: red">Cargo: {{record.cargo.Name}}</span>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <span v-if="record.ocrd">
              Cargo Date: {{record.DocDate}}
              <br />
              <span v-if="record.store">Store: {{record.store.Name}}</span>
            </span>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <DatePicker @date="setDate" :myDate="DocDate" :title="`Date Received`"></DatePicker>
          </v-col>

          <v-col cols="12">
            <v-data-table
              :mobile-breakpoint="0"
              light
              :items-per-page="pageItems"
              :headers="headers"
              :items="record.rows"
              item-key="o_i_t_m_s_id"
              hide-default-footer
              disable-sort
            >
              <template v-slot:item.Name="{ item }">
                <span v-if="item.product">{{item.product.Name}}</span>
              </template>
              <template v-slot:item.OpenQty="{ item }">
                <v-text-field
                  style="width: 100px"
                  name="cargoDeliveryQuantity"
                  class="orderInput"
                  single-line
                  outlined
                  dense
                  v-model="item.OpenQty"
                ></v-text-field>
              </template>
              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price">{{item.Price.toLocaleString()}}</span>
              </template>
              <template v-slot:item.LineTotal="{ item }">
                <span v-if="item.LineTotal">{{item.LineTotal.toLocaleString()}}</span>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" xs="12" md="3" class="justify-right">
            <v-autocomplete
              autocomplete="off"
              name="cargoDeliveryCopyTo"
              dense
              outlined
              v-model="targetObj"
              :items="copyData"
              label="Copy To"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3" class="justify-right">
            <v-autocomplete
              hide-details
              dense
              outlined
              v-model="store"
              :items="stores"
              label="Select Store"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <!-- <v-col cols="12" xs="12" md="6" class="justify-right"></v-col> -->
          <v-col cols="12" xs="12" md="12">
            <v-btn color="accent" :loading="loader" @click="save">
              <v-icon left>mdi-content-save</v-icon>Save
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    record: {},
    DocNum: null,
    loader: false,
    store: null,
    stores: [],
    docCreate: false,
    copyStatus: false,
    DocDate: new Date().toISOString().substr(0, 10),
    copyData: [{ Name: "Goods Receipt", id: 12 }],
    targetObj: null,
    pageItems: 100,
    headers: [
      { text: "Product", value: "Name" },
      { text: "Received From Supplier", value: "Quantity" },
      { text: "Delivered", value: "DeliveredQty" },
      { text: "With Cargo", value: "OpenQty" },
      // { text: "Purchase UOM", value: "UomEntry" },
      // { text: "Price", value: "Price" },
      // { text: "Tax", value: "TaxId" },
      // { text: "Cargo Value", value: "LineTotal" },
      // { text: "Action", value: "action" },
    ],
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/documents/24/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.record = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.DocDate = date;
    },
    save() {
      if (this.store == null || this.store == undefined) {
        this.$refs.snackbar.show("Please select store!", "red");
      } else {
        if (this.targetObj == null || this.targetObj == undefined) {
          this.$refs.snackbar.show("Please select Copy To!", "red");
        } else {
          const data = {
            store_id: this.store,
            cargo_id: this.record.cargo_id,
            CardCode: this.record.CardCode,
            DocDate: this.DocDate,
            ObjType: 12,
            BaseType: 24,
            BaseEntry: this.record.id,
            rows: this.record.rows,
          };

          const url = "/copy/document";
          this.loader = true;
          const self = this;
          this.$store
            .dispatch("post", { url, data })
            .then((res) => {
              if (res.ResultCode == 1200) {
                self.$store.commit("btnLoader", false);
                self.$router.push("/goods/receipt");
              } else {
                self.$store.commit("btnLoader", false);
                this.$refs.snackbar.show(res.ResultDesc, "red");
              }
            })
            .catch((err) => {
              self.$store.commit("btnLoader", false);
              this.$refs.snackbar.show(err, "red");
            });
        }
      }
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/12`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (self.docCreate == true) {
              self.DocNum = res.ResponseData.NextNumber;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getDocNum();
    this.getStores();
  },
};
</script>